export const blockIconsAudioandvideoSpeed = (
	<span className='material-symbols-outlined'>speed</span>
);
